import { DEFAULT_PALETTE, isValidPaletteKey, PALETTES, type PaletteKey } from '../theme/palettes';

const VAR_MAP: Record<string, keyof (typeof PALETTES)[PaletteKey]> = {
  '--c-sidebar': 'sidebar',
  '--c-nav': 'nav',
  '--c-bg': 'bg',
  '--c-sage': 'sage',
  '--c-terracotta': 'terracotta',
  '--c-btn-voir': 'btnVoir',
  '--c-btn-valider': 'btnValider',
  '--c-btn-revoir': 'btnRevoir',
  '--c-text': 'textMain',
  '--c-muted': 'textMuted',
  '--c-border': 'border',
  '--c-pages-scroll-bg': 'pagesScrollBg',
};

const STORAGE_KEY = 'portail-bim-ambiance';

export function applyPalette(key: PaletteKey) {
  const palette = PALETTES[key];
  const root = document.documentElement;
  for (const [cssVar, field] of Object.entries(VAR_MAP)) {
    root.style.setProperty(cssVar, palette[field] as string);
  }
  document.body.dataset.ambiance = key;
  try {
    localStorage.setItem(STORAGE_KEY, key);
  } catch {
    /* noop */
  }
}

export function loadPaletteFromStorage(): PaletteKey {
  try {
    const s = localStorage.getItem(STORAGE_KEY);
    if (isValidPaletteKey(s)) return s;
  } catch {
    /* noop */
  }
  return DEFAULT_PALETTE;
}

export function resolvePalette(userMood: string | null | undefined): PaletteKey {
  if (isValidPaletteKey(userMood)) return userMood;
  return loadPaletteFromStorage();
}
